const fieldValidation = {
  required: 'จำเป็นต้องระบุ{{fieldName}}',
  pattern: '{{fieldName}} is invalid',
};

export default fieldValidation;
